import { useEffect } from 'react'
import { View } from 'react-native'
import Animated, {
  Easing,
  cancelAnimation,
  useAnimatedStyle,
  useSharedValue,
} from 'react-native-reanimated'
import { colors } from '@ui/colors'
import HandStopIcon from './assets/hand-stop'
import {
  buildPhaseLoop,
  AnimationComponentProps as Props,
} from './phaseAnimation'

const REFERENCE_SIZE = 24

const ICON_SIZE = [18, 26]

const PHASE_DURATIONS = [600, 300]
const PHASE_DELAYS = [1200, 0]
const PHASE_EASINGS = [Easing.out(Easing.ease), Easing.in(Easing.ease)]

export default function HandStop({
  size = REFERENCE_SIZE,
  color = colors.white,
  durations = PHASE_DURATIONS,
  delays = PHASE_DELAYS,
  easings = PHASE_EASINGS,
  isActive = true,
}: Props) {
  const scale = size / REFERENCE_SIZE

  const iconSize = useSharedValue(ICON_SIZE[0] * scale)

  useEffect(() => {
    if (!isActive) {
      cancelAnimation(iconSize)
      return
    }

    iconSize.set(
      buildPhaseLoop(
        ICON_SIZE.map((value) => value * scale),
        durations,
        delays,
        easings
      )
    )
  }, [isActive, scale, durations, delays, easings, iconSize])

  const iconStyle = useAnimatedStyle(() => ({
    width: iconSize.value,
    height: iconSize.value,
  }))

  return (
    <View
      style={{ width: size, height: size }}
      className="items-center justify-center"
    >
      <Animated.View style={iconStyle}>
        <HandStopIcon size="100%" color={color} />
      </Animated.View>
    </View>
  )
}
